/**
 * Name: Burger
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Burger extends Collapsible {
  static settings = {
    control: '.js-burger-control',
    target: '.js-burger-target',
  };

  constructor (element, options = {}) {
    super(element, {
      ...Burger.settings,
      ...options,
    });
  }

  get isDisplayed () {
    return getComputedStyle(this.element).display !== 'none';
  }

  open () {
    super.open();

    requestAnimationFrame(() => {
      document.querySelector('.js-header').classList.remove('close');
      document.querySelector('.js-header').classList.add('open');
    });

    this.target.focus();
    document.documentElement.classList.add('no-scroll');
  }

  close () {

    const header = document.querySelector('.js-header');

    header.classList.remove('open');
    header.classList.add('close');

    document.documentElement.classList.remove('no-scroll');

    this.target.addEventListener('transitionend', () => {
      super.close();
      this._pointerTriggered = false;
    }, { once: true });
  }

  mount () {
    super.mount();

    this.target.classList.add('has-burger');
    this.target.setAttribute('tabindex', '-1');

    this._pointerTriggered = false;
    this._onControlPointerdown = () => { this._pointerTriggered = true; };
    this._onControlKeydown = () => { this._pointerTriggered = false; };
    this.control.addEventListener('pointerdown', this._onControlPointerdown);
    this.control.addEventListener('keydown', this._onControlKeydown);
  }

  unmount () {
    super.unmount();

    this.target.classList.remove('has-burger');
    this.target.removeAttribute('tabindex');

    this.element.classList.remove('open', 'close');

    this.control.removeEventListener('pointerdown', this._onControlPointerdown);
    this.control.removeEventListener('keydown', this._onControlKeydown);
  }
}
